<template>
    <div class="d-flex align-items-center gap-3">
        <router-link 
            :to="'/v1/unidades'" 
            class="nav-link px-1 py-2 rounded-pill fw-semibold"
            :style="isActive('UnidadesPage')"
        >
            MINHAS UNIDADES
        </router-link>
        <span class="text-muted fw-bold">|</span>
        <router-link 
            :to="'/v1/consulta-avancada'" 
            class="nav-link px-1 py-2 rounded-pill fw-semibold"
            :style="isActive('ConsultaAvancadaPage')"
        >
            CONSULTA AVANÇADA
        </router-link>
    </div>
</template>
<script>
export default {
    name: "ConsultaSwitch",
    methods: {
		isActive(route) {
			const ativo = this.$route.name === route || this.$route.path.includes(route);
			return {
				fontWeight: ativo ? 'bold' : 'normal',
				color: ativo ? '#33b35a' : '#000',
				textDecoration: 'none'
			};
		},
	},
};
</script>